<template>
  <div class="hero is-fullheight is-relative">
      <div class="hero-head absolute">
        <Navbar @dark="changeDark"></Navbar>
      </div>
      <div class="hero-body" data-aos="fade-right">
        <div class="container">
            <h1 class="heading-text">Poszukujesz <span class="primary">profesjonalnego</span> bota, który spełni wszystkie twoje oczekiwania?</h1>
            <div class="descContainer mt-2">
                <a class="btn" :href="getENV('ADD_BOT')" target="_blank">Dodaj mnie!</a>
                <a class="ic" :href="getENV('YOUTUBE')" target="_blank"><font-awesome-icon icon="fa-brands fa-youtube"></font-awesome-icon></a>
                <a class="ic" :href="getENV('INSTAGRAM')" target="_blank"><font-awesome-icon icon="fa-brands fa-instagram"></font-awesome-icon></a>
                <a class="ic" :href="getENV('DISCORD')" target="_blank"><font-awesome-icon icon="fa-brands fa-discord"></font-awesome-icon></a>
                <a class="ic" :href="getENV('TIKTOK')" target="_blank"><font-awesome-icon icon="fa-brands fa-tiktok"></font-awesome-icon></a>
            </div> 
        </div>
       </div>
        <img src="/images/storm.svg" class="storm">
        <div class="head-foot is-clickable">
            <font-awesome-icon icon="fa-solid fa-angle-down"  class="angleDown"
                @click="scrollTo('naszeZalety')">
            </font-awesome-icon>
        </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import { getENV, scrollTo } from '@/utils.js'

export default {
    components: {
        Navbar
    }, methods: {
        getENV, scrollTo,
        changeDark(value) {
            this.$emit('dark', value);
        }
    }
}
</script>

<style scoped lang="scss">
@import "~bulma/sass/utilities/mixins";

.storm {
    position: absolute;
    z-index: 1;
    top: 65%;
    right: 1%;
    transform: translateY(-50%) scale(.60);

    @include until-fullhd {
        z-index: 0;
        opacity: .3;
    }
}

.heading-text {
    font-size: 2rem;
    color: rgb(255, 255, 255);
    font-weight: 750;
    font-family: "Poppins", sans-serif;
    width: 70%;

    @include touch {
        // font-size: 1.25rem;
        // font-size: 1.5rem;
        // font-size: 2vw;
        width: 70%;
        font-size: clamp(1.5rem, 4vw, 2rem);
    }

    @include mobile {
        width: 100%;
    }
}


.descContainer {
    display: flex;
    align-items: center;
    gap: 20px;
}

.ic {
    color: #c1c1c1;
    font-size: 2.25rem;

    @include touch {
        font-size: 1.8rem;
    }
}

.absolute {
    position: absolute;
    width: 100%;
    z-index: 3;
}

.angleDown {
    position: absolute;
    left: 0;
    right:0;
    margin: 0 auto;
    
    font-size: 3.25rem;
    color: var(--primary);
    bottom: 20px;

    cursor: pointer;
    animation: bounce 2s infinite;
    z-index: 10;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(-35px);
  }

  40% {
    transform: translateY(-15px);
  }

  60% {
    transform: translateY(-20px);
  }
}

.hero-body {
    z-index: 1;
    position: relative;
}
</style>
